import React, { useEffect, useState } from "react";
import "./SignUp.css";
import AppLayout from "../../../layout/AppLayout";
import { FaMobileAlt, FaEnvelope } from "react-icons/fa";
import { Button, Form } from "react-bootstrap";
import Email_SignUp from "./Email_SignUp/Email_SignUp";
import Phone_Number_SignUp from "./Phone_Number_SignUp/Phone_Number_SignUp";
import { useLocation, useNavigate } from "react-router-dom";
import Login_Header from "../../Common/Common_Component/Login_Header/Login_Header";
import Successfull_strip_modal from "../../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { AuthSignUp } from "../../../features/auth/Slice";

const SignUp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("phone");
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("Register Successfully!");

  const location = useLocation();

  const {
    control,
    register,
    resetField,
    handleSubmit,
    watch,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      contact_no: "",
      email: "",
      password: "",
      confirm_password: "",
      privacyAgreement: false,
    },
  });

  const [contact_no, email, password] = watch([
    "contact_no",
    "email",
    "password",
  ]);
  const showCss = (activeTab === "phone" ? contact_no : email) && password;

  // Clear opposite tab's field on tab switch
  useEffect(() => {
    if (activeTab === "phone") {
      resetField("email");
    } else {
      resetField("contact_no");
    }
  }, [activeTab]);

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("type", activeTab);
      formData.append("password", data?.password);
      formData.append("confirm_password", data?.confirm_password);
      formData.append("privacyAgreement", data?.privacyAgreement);
      formData.append("refer_code", data?.refer_code);
      formData.append("contact_no", data?.contact_no);
      formData.append("email", data?.email);

      if (activeTab === "phone") {
      } else {
      }

      const res = await dispatch(AuthSignUp(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        setModalMessage("Register Successfully!");
        setModalShow(true);
        setTimeout(() => {
          setModalShow(false);
          navigate("/login");
        }, 3000);
      } else if (res.meta?.requestStatus === "rejected") {
        console.error("SignUp rejected:", res.error);
        setModalShow(true);
        setModalMessage(res?.payload?.errors || "Registration failed.");

        setTimeout(() => {
          setModalShow(false);
        }, 3000);
      }
    } catch (error) {
      console.error("SignUp failed:", error);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const refCode = params.get("ref");

    if (refCode) {
      // Set referral code in react-hook-form
      setValue("refer_code", refCode);

      // Remove query parameter from URL
      navigate(location.pathname, { replace: true });
    }
  }, [location.search, location.pathname, navigate, setValue]);

  return (
    <>
      <div className="login-page SignUp">
        {/* Header */}
        <Login_Header
          title="Register"
          subTitle="Please Register with your phone number and email"
        />

        {/* Body */}
        <div className="login-body">
          {/* Tabs */}
          {/* <div className="login-tabs">
            <div
              className={`tab ${activeTab === "phone" ? "active" : ""}`}
              onClick={() => setActiveTab("phone")}
            >
              <div>
                <FaMobileAlt />
              </div>
              Phone Number
            </div>

            <div
              className={`tab ${activeTab === "email" ? "active" : ""}`}
              onClick={() => setActiveTab("email")}
            >
              <div>
                <FaEnvelope />
              </div>
              Email Sign Up
            </div>
          </div> */}

          <Form onSubmit={handleSubmit(onSubmit)} noValidate>
            {/* Phone Field */}
            {activeTab === "phone" && (
              <Phone_Number_SignUp
                control={control}
                register={register}
                errors={errors}
                watch={watch}
              />
            )}

            {/* Email Field */}
            {activeTab === "email" && (
              <Email_SignUp register={register} errors={errors} watch={watch} />
            )}

            {/* Privacy Agreement */}
            <div className="privacy_check mb-3">
              <Form.Check
                type="checkbox"
                label={
                  <>
                    I have read and agree{" "}
                    <span
                      className="privacy_link"
                      onClick={() => navigate("/risk-disclosure-agreement")}
                    >
                      [Privacy Agreement]
                    </span>
                  </>
                }
                {...register("privacyAgreement", {
                  required: "You must agree to the Privacy Agreement",
                })}
              />
              {errors.privacyAgreement && (
                <small className="text-danger">
                  {errors.privacyAgreement.message}
                </small>
              )}
            </div>

            {/* Buttons */}
            <Button
              type="submit"
              className={showCss ? "btn_register_bg mb-3" : "btn-login mb-3"}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Registering..." : "Register"}
            </Button>
          </Form>

          <Button className="btn-register mb-3">
            <span className="span_text">I have an account </span>
            <span onClick={() => navigate("/login")}>Login</span>
          </Button>
        </div>
      </div>

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </>
  );
};

export default SignUp;
